module.exports = __webpack_public_path__ + "static/media/8.b33b54d7.png";